import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Paper } from '@mui/material';
import { Search } from '@mui/icons-material';
import { TextField, IconButton } from '@totalsoft/rocket-ui';
import BrowserContainer from './BrowserContainer';
import { emptyString } from 'constants/emptyConst';

const ContainerWrapperIntern = ({
  value,
  disabled,
  label,
  onTextFieldChange,
  helperText,
  required,
  iconHidden,
  error,
  hasCustomIcons,
  iconDisabled,
  customEndIcons,
  Container,
  onBlur,
  isBrowserOpen,
  setIsBrowserOpen,
  partnerTypeId
}) => {
  return (
    <>
      <TextField
        fullWidth
        name='value'
        value={value ?? emptyString}
        disabled={disabled}
        label={label}
        onChange={onTextFieldChange}
        onBlur={onBlur}
        error={error}
        id={'TextFieldId'}
        helperText={helperText}
        required={required}
        endAdornment={
          !iconHidden ? (
            hasCustomIcons ? (
              customEndIcons
            ) : (
                <IconButton
                  disabled={iconDisabled ?? disabled}
                  color='primary'
                  variant='text'
                  size='tiny'
                  onClick={() => setIsBrowserOpen(true)}
                >
                  <Search />
                </IconButton>
            )
          ) : undefined
        }
      />
      <Modal onClose={() => setIsBrowserOpen(!isBrowserOpen)} open={isBrowserOpen}>
        <>
          {isBrowserOpen && (
            <Paper>
              <BrowserContainer
                onTextFieldChange={onTextFieldChange}
                Container={Container}
                setOpenModal={setIsBrowserOpen}
                partnerTypeId={partnerTypeId}
              ></BrowserContainer>
            </Paper>
          )}
        </>
      </Modal>
    </>
  );
};
ContainerWrapperIntern.propTypes = {
  value: PropTypes.any,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onTextFieldChange: PropTypes.func.isRequired,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
  iconHidden: PropTypes.bool,
  error: PropTypes.bool,
  hasCustomIcons: PropTypes.bool,
  iconDisabled: PropTypes.bool,
  customEndIcons: PropTypes.node,
  Container: PropTypes.func.isRequired,
  hasSimpleValue: PropTypes.bool,
  onBlur: PropTypes.func.isRequired,
  setIsBrowserOpen: PropTypes.func.isRequired,
  isBrowserOpen: PropTypes.bool.isRequired,
  partnerTypeId: PropTypes.number
};

export default ContainerWrapperIntern;
